export default __webpack_public_path__ + "static/media/close.ff83b1be.svg";